module.exports = "<commuter-package-page></commuter-package-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appPlans/commuterPackage.html
// module id = 2030
// module chunks = 0